import { logWrapper } from '../utils';
import jQuery from 'jquery';

function ddv4TooltipDirectiveFactory(runtimeConstant, $timeout) {
  function link(scope, element) {

    $timeout(() => {
      if (!window.jQuery) {
        return;
      }

      if (scope.trigger !== undefined && scope.trigger !== null && scope.trigger !== '') {
        element.attr('data-toggle', 'tooltip');

        if (
          element.attr('data-placement') === undefined ||
          element.attr('data-placement') === ''
        ) {
          element.attr('data-placement', 'top');
        }

        element.attr('data-original-title', scope.trigger);
        element.attr('data-container', 'body');
        element.attr('data-trigger', 'manual');

        element.on('click', function () {
          if (element.hasClass('clicked')) {
            element.removeClass('clicked');
            jQuery(element).tooltip('hide');
          } else {
            element.addClass('clicked');
            jQuery(element).tooltip('show');
          }
        });
        element.on('mouseenter', function () {
          jQuery(element).tooltip('show');
        });
        element.on('mouseleave', function () {
          element.removeClass('clicked');
          jQuery(element).tooltip('hide');
        });
        element.on('$destroy', function () {
          jQuery('.tooltip').remove();
        });
      }
    }, 1000); // Atraso de 1000ms para garantir o carregamento do jQuery
  }

  function run() {
    return {
      restrict: 'A',
      scope: {
        trigger: '@ddv4Tooltip',
      },
      link: link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const ddv4TooltipDirective = ['runtimeConstant', '$timeout', ddv4TooltipDirectiveFactory];